<div class="auth-shell">
  <router-outlet />
</div>
